import React from 'react';

import LogoIcon from './logo.svg?react';

export const Logo: React.FC = () => (
  <div className="logo">
    <LogoIcon />
  </div>
);
